import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import SetPassword from './pages/SetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import ConnectionSettings from './pages/ConnectionSettings';
import JobHistory from './pages/JobHistory';
import JobDetail from './pages/JobDetail';
import AdminTenants from './pages/AdminTenants';
import Administrators from './pages/Administrators';
import Layout from './components/shared/Layout';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{
          style: { fontFamily: "'DM Sans', sans-serif", fontSize: '14px' },
          success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
          error:   { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
        }} />
        <Routes>
          <Route path="/login"           element={<Login />} />
          <Route path="/set-password"    element={<SetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index                  element={<Dashboard />} />
            <Route path="jobs"            element={<JobHistory />} />
            <Route path="jobs/:id"        element={<JobDetail />} />
            <Route path="connection"      element={<ConnectionSettings />} />
            {/* Legacy redirects so old bookmarks still work */}
            <Route path="sftp"            element={<Navigate to="/connection" replace />} />
            <Route path="settings"        element={<Navigate to="/connection" replace />} />
            <Route path="files"           element={<Navigate to="/jobs" replace />} />
            <Route path="admin/tenants"         element={<ProtectedRoute adminOnly><AdminTenants /></ProtectedRoute>} />
            <Route path="admin/administrators" element={<ProtectedRoute adminOnly><Administrators /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
